import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetallCheckBalance } from "../Features/Checkbalance";
import { RootState, AppDispatch } from "../Appstore/store";
import { RenderPaginationButtons } from "../Components/Paginations";

function Checkbalance() {
    const [search, setSearch] = useState<string>("");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const limit = 10;
    const dispatch = useDispatch<AppDispatch>();
    const { checkbalancedata, info, loading } = useSelector(
        (state: RootState) => state.checkbalance
    );

    const [debouncedSearch, setDebouncedSearch] = useState<string>(search);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search.trim());
        }, 800);

        return () => {
            clearTimeout(handler);
        };
    }, [search]);

    useEffect(() => {
        dispatch(
            GetallCheckBalance({
                search: debouncedSearch,
                page: currentPage,
                limit: limit,
            })
        );
    }, [dispatch, debouncedSearch, currentPage, limit]);

    useEffect(() => {
        if (currentPage > info?.total_page!) setCurrentPage(info?.total_page || 1);
    }, [info]);

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="wrapper">
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <div className="card mt-4">
                            <div className="card-header bg-white p-3 d-sm-flex justify-content-md-between align-items-center">
                                <h2 className="w-100 text-sm-start text-center mb-md-2 mb-3 fs-3">
                                    Check Balance
                                </h2>
                                <div className="d-md-flex justify-content-between align-items-center mb-md-0 mb-3">
                                    <div className="input-group input-group-sm pe-sm-3 mb-sm-0 mb-3" style={{ width: "100%" }}>
                                        <input
                                            type="search"
                                            className="form-control float-right height-40px shadow-none"
                                            placeholder="Search"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                        <div className="input-group-append">
                                            <button
                                                type="submit"
                                                className="btn border cursor-pointer-none"
                                            >
                                                <i className="fas fa-search" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                <>
                                    <div className="table-responsive">
                                        <table className="table table-hover table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th className="ps-3 sr-no">SR No</th>
                                                    <th style={{ minWidth: 200 }}>Name</th>
                                                    <th className="text-center">Gateway Name</th>
                                                    <th className="text-center phone">Balance</th>
                                                    <th className="text-center role">Currency</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan={5} height={100}>
                                                            <div className="text-center">
                                                                <div className="loader"></div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : !checkbalancedata || checkbalancedata.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={5} height={50}>
                                                            <div className="text-center">
                                                                <p className="mb-0 fs-5 fw-semibold">
                                                                    No data found
                                                                </p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    checkbalancedata.map((item, index) => (
                                                        <tr key={item.id}>
                                                            <td className="ps-3">
                                                                {(currentPage - 1) * limit + index + 1}
                                                            </td>
                                                            <td>{item.name || '-'}</td>
                                                            <td className="text-center">{item.gateway.name || '-'}</td>
                                                            <td className="text-center">
                                                                {item.balance || '-'}
                                                            </td>
                                                            <td className="text-center">
                                                                {item.currency || '-'}
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {!checkbalancedata || checkbalancedata.length === 0 ? (
                                        <div></div>
                                    ) : (
                                        <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                            <RenderPaginationButtons
                                                info={info}
                                                currentPage={currentPage}
                                                handlePageChange={handlePageChange}
                                            />
                                        </div>
                                    )}
                                </>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Checkbalance;
